import React, { useEffect, useState } from 'react';
import Security from '../../../../api/models/fixProtocol/instrument/security';
import { formatFundName, formatCnpj } from '../../../../app/utils'

interface EditPositionFundsListItemProps {
  fund: Security
}

/**
 * Form to add and edit a simple position, which helds some quantity of a security and no custom fields are necessary to detail the security.
 */
const EditPositionFunds: React.FC<EditPositionFundsListItemProps> = (props: EditPositionFundsListItemProps) => {

  return (
    <div className='flex flex-col w-full px-2 pt-2 text-xs font-normal'>
      <div className='flex flex-col w-full'>
        {formatFundName(props.fund.symbol)}
      </div>
      <div className='flex flex-col w-full pt-1 font-semibold'>
        CNPJ: {formatCnpj(props.fund.cnpj)}
      </div>
    </div>
  );
}

export default EditPositionFunds;